import Style from "./CouponBrick.module.less";
import FJLocalStore from "../../store/FJLocalStore";
import {useCallback, useEffect, useRef, useState} from "react";
import classNames from "classnames";
import FJButton from "../common/FJButton/FJButton";
import {useDispatch, useSelector} from "react-redux";
import mainAction from "../../reducer/action/mainAction";
import FJMessageStore from "../../store/FJMessageStore";
import FJUtil from "../../util/FJUtil";

let CouponBrick = (props) => {
    let {countPrice, isAnnually, plan, active} = props

    let [hasInput, setHasInput] = useState(false)
    let [loading, setLoading] = useState(false)
    // let appliedCoupon = useRef(null)
    // let Coupon = useRef(null)
    // let couponObject = useRef({})
    // let estimateAmount = useRef(null)
    // let freeOfCharge = useRef(null)

    let inputRef = useRef(null)
    let dispatch = useDispatch()
    let {show, selectPage, payMethod, dataInfo, discountConf, seatCount, additionalSeatCount, planType, currentPlan, teamSubscription } = useSelector(state => {
        return {
            show: state.mainReducer.show,
            selectPage: state.mainReducer.selectPage,
            payMethod: state.mainReducer.payMethod,
            dataInfo: state.mainReducer.dataInfo,
            discountConf: state.mainReducer.discountConf,
            seatCount: state.mainReducer.seatCount,
            additionalSeatCount: state.mainReducer.additionalSeatCount,
            planType: state.mainReducer.planType,
            currentPlan: state.mainReducer.currentPlan,
            teamSubscription: state.mainReducer.teamSubscription,
        }
    })
    const teamId = planType === 'team' ? teamSubscription?.id : null;
    let isUpgrade = () => {
        if (planType === 'team') {
            return teamSubscription && teamSubscription.package !== 'free'
        }
        return currentPlan.package !== 'free';
    }

    let getPlan = () => {
        let selectPeriod = isAnnually ? 'annual' : 'monthly';
        let _page = selectPage === 'free' ? 'basic' : selectPage
        if (planType === 'team') {
            _page = 'team_business';
        }
        return _page + '_' + selectPeriod;
    }

    useEffect(() => {
		let coupon = "";
		if (discountConf.openDiscount) {
			coupon = discountConf.coupon
		} else {
			coupon = FJUtil.getCookie('coupon');
		}
		if (coupon) {
			let plan = getPlan();
			dispatch(mainAction.changeLoadingStatusAction(true))
			window.FJGlobalariable.modSubscription.network.redeemCoupon(coupon, plan, isUpgrade(), teamId).then(res => {
				switch (res.code) {
					case 200:
						if (res.data.allow_coupon) {
							inputRef.current.value = coupon;
							window.FJGlobalariable.modSubscription.state.appliedCoupon = coupon
							dispatch(mainAction.setDataInfo({
								appliedCoupon: coupon,
								coupon: coupon,
								couponObject: res.data.coupon_object,
								estimateAmount: res.data,
								freeOfCharge: res.data.free_of_charge,
							}))
						}
				}
			}).catch(err => {
				console.log(err);
				dispatch(mainAction.changeLoadingStatusAction(false))
			}).finally(() => {
				window.FJGlobalariable.modSubscription.showLoading = false;
				dispatch(mainAction.changeLoadingStatusAction(false))
			});
		} else {
			dispatch(mainAction.setDataInfo({
				appliedCoupon: null,
			}))
		}
    }, [discountConf])


    let _onClick = () => {
        setHasInput(!hasInput)
    }
    let _onChange = (event) => {
        let value = event.target.value;
        if (!/^(|[a-zA-Z0-9_]{0,50})$/.test(value)) {
            event.target.value = value.substr(0, 50)
        }
    }

    let redeemCoupon = (callback) => {
        // if (this.isRedeemButtonDisabled) {
        //     return;
        // }
        // let coupon = dataInfo.coupon;
        let coupon = inputRef.current.value;
        let plan = getPlan();

        // this.isRedeeming = true;
        dispatch(mainAction.changeLoadingStatusAction(true))
        setLoading(true)
        window.FJGlobalariable.modSubscription.network.redeemCoupon(coupon, plan, isUpgrade(), teamId).then(res => {
            switch (res.code) {
                case 200:
                    if (res.data.allow_coupon) {
                        setHasInput(false); // 关闭优惠码输入窗口
                        // 展示预估价格
                        window.FJGlobalariable.modSubscription.state.appliedCoupon = coupon
                        dispatch(mainAction.setDataInfo({
                            appliedCoupon: coupon, // 设置应用后的coupon
                            coupon: coupon,
                            couponObject: res.data.coupon_object,
                            estimateAmount: res.data,
                            freeOfCharge: res.data.free_of_charge
                        }))
                    } else {
                        // 不可使用coupon
                        // dataInfo.appliedCoupon = null;
                        dispatch(mainAction.setDataInfo({
                            appliedCoupon: null,
                        }))
                        FJMessageStore.addMessage(FJLocalStore._('COM_FJ_SP_COUPON_CONTINUOUS'), 'warning');
                    }
                    break;
                case 214:
                    FJMessageStore.addMessage(FJLocalStore._('PAGE_EXPIRED'), 'warning');
                    break;
                default:
                    // dataInfo.appliedCoupon = null;
                    dispatch(mainAction.setDataInfo({
                        appliedCoupon: null,
                    }))
                    if (res.msg === 'SUB.COM_FJ_SP_COUPON_MATCH_PLAN_ERROR') {
                        let list = res.data.split(', ');
                        list = list.map(item => {
                            let list = item.split(' ');
                            list = list.map(item => {
                                return FJLocalStore._(item.toUpperCase())
                            });
                            return list.join('');
                        });
                        let MSG = res.msg.replace("SUB.", '')
                        if (window.text_printf) {
                            FJMessageStore.addMessage(window.text_printf(FJLocalStore._(MSG), list.join(', ')), 'warning');
                        }
                    }else if(res.msg === 'SUB.CANNOT_USED_FOR_UPGRADE'){
                        FJMessageStore.addMessage(FJLocalStore._('CANNOT_USED_FOR_UPGRADE'), 'warning');
                    } else {
                        let MSG = res.msg.replace("SUB.", '')
                        if (window.text_) {
                            FJMessageStore.addMessage(window.text_(FJLocalStore._(MSG)), 'warning');
                        }
                    }
            }
        }).catch(err => {
            // dataInfo.appliedCoupon = null;
            dispatch(mainAction.setDataInfo({
                appliedCoupon: null,
            }))
            FJMessageStore.addMessage(FJLocalStore._('COM_FJ_SP_COUPON_NOT_EXIST'), 'warning');
            console.log(err);
        }).finally(() => {
            // this.isRedeeming = false;
            setLoading(false)
            if (typeof callback === "function") {
                callback();
            }
            dispatch(mainAction.changeLoadingStatusAction(false))
        });
    }
    let _submit = () => {
        // let value = inputRef.current.value;
        redeemCoupon()
    }
    let _autoPayPrice = () => {
        let price;
        if (plan.package === 'team') {
            if (additionalSeatCount) {
                price = isAnnually ? additionalSeatCount * plan.seatPrice.annual * 12 : additionalSeatCount * plan.seatPrice.monthly
            } else {
                price = isAnnually ? plan.price.annual * 12 + (seatCount-3) * plan.seatPrice.annual * 12 : plan.price.monthly + (seatCount-3) * plan.seatPrice.monthly
            }
        } else {
            price = isAnnually ? plan.price.annual * 12 : plan.price.monthly
        }
        return price.toFixed(2);
    }

    let _realPrice = () => {
        if (dataInfo.appliedCoupon && dataInfo.couponObject) {
            let amount = _autoPayPrice();
            if (dataInfo.couponObject.amount_off) {
                amount = (amount - dataInfo.couponObject.amount_off).toFixed(2);
            } else if (dataInfo.couponObject.percent_off) {
                amount = ((1 - parseFloat(dataInfo.couponObject.percent_off) / 100) * amount).toFixed(2);
            }

            if (amount < 0)
                amount = 0;
            return amount;
        } else {
            return _autoPayPrice();
        }
    }

    useEffect(() => {
        if (inputRef.current.value && active) {
            redeemCoupon();
        }
    }, [isAnnually, active]);

    return (
        <>
            <div className={Style.total_billed_box}>
                <div>
                    <span>{FJLocalStore._('TOTAL_BILLED')}:</span>
                    <span className={Style.curPrice}>{'$' + _realPrice()}</span>
                    {dataInfo.appliedCoupon !== null &&
                        <span className={Style.oldPrice}>{'$' + _autoPayPrice()}</span>}
                </div>
                <div className={Style.coupon_box}>
                    <span className={Style.coupon_entry} onClick={_onClick}>{FJLocalStore._('HAVE_A_COUPON')}</span>
                    <div
                        className={classNames(Style.input_box, {[Style.input_box_show]: hasInput})}
                    >
                        <input className={Style.input} ref={inputRef} onChange={_onChange}
                               placeholder={FJLocalStore._('REDEEM_PLACEHOLDER')}/>
                        <FJButton
                            isLoading={loading}
                            className={Style.btn}
                            onClick={_submit}
                            text={FJLocalStore._('REDEEM')}
                        />
                        {/*<div className={}>{FJLocalStore._('TOTAL_BILLED')}</div>*/}

                    </div>
                </div>
            </div>
            {dataInfo.appliedCoupon !== null &&
                <span className={Style.tip}>{FJLocalStore._('REDEEM_SUCCESSFUL')}</span>}
            <div className={Style.pay_message}
                 dangerouslySetInnerHTML={{
                     __html: additionalSeatCount ? FJLocalStore._('new-member-paying-description') : isAnnually ? FJLocalStore._('YOU_WILL_CHARGED_YEAR').replace('%s', _autoPayPrice()) : FJLocalStore._('YOU_WILL_CHARGED').replace('%s', _autoPayPrice())
                 }}
            />
        </>
    )
}
export default CouponBrick